// extracted by mini-css-extract-plugin
export default {"padding":"RenderIf_padding__9ODpS","center":"RenderIf_center__sQH9k","isAdmin":"RenderIf_isAdmin__X3G9H","isTestAccount":"RenderIf_isTestAccount__00m-z"};